import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Cidade } from '../../models/cidades/cidade';

@Injectable({
  providedIn: 'root'
})

export class CidadeService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getCidadeByEstado(sigla_uf: string): Observable<Cidade[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "sigla_uf": sigla_uf
    };

    return this.http.post<Cidade[]>(this.baseUrl + "api/Cidade/GetCidadeByEstado", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }
}
